module.exports = __webpack_public_path__ + "img/chapter-logo.e8e86a49.svg";